import { render, staticRenderFns } from "./FullWidthHorizontalScroll.vue?vue&type=template&id=66fc5815&scoped=true&"
import script from "./FullWidthHorizontalScroll.vue?vue&type=script&lang=js&"
export * from "./FullWidthHorizontalScroll.vue?vue&type=script&lang=js&"
import style0 from "./FullWidthHorizontalScroll.vue?vue&type=style&index=0&id=66fc5815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fc5815",
  null
  
)

export default component.exports